import React from 'react';
import { actions } from './Dialog';
import { InfoMessage } from './texts';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

export default function CancelLineConfirmation({
  setOptionNumber,
  changes,
  setChangedRequestInfo,
  open,
  endRequest = null,
}) {
  const header = 'Cancel Active Line';

  const content = `Please note, you are only able to request the cancellation of upcoming
  stages in your supply chain. Cancelling an Active Line will result in a
  re-calculation of your Active Growth Plan,  which can take
  up to 48 hours. Your Active Growth Plan will remain in effect until you
  approve any changes.
`;

  const action = (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        setChangedRequestInfo({
          ...changes,
        });
        setOptionNumber(actions.addMessage);
      }}
    >
      <b>Continue</b>
    </Button>
  );

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      actions={action}
      onClose={endRequest}
      info={InfoMessage}
    />
  );
}
